import React, { useState, useEffect } from "react";
import {
  createViewState,
  JBrowseLinearGenomeView,
  loadPlugins,
} from "@jbrowse/react-linear-genome-view";
import { assembly, tracks } from "../config/JbrowseConfig";

const session = {
  name: "my session",
  view: {
    id: "linearGenomeView",
    type: "LinearGenomeView",
    tracks: [
      {
        type: "FeatureTrack",
        configuration: "potra_genes",
        displays: [
          {
            type: "LinearBasicDisplay",
            configuration: "potra_genes-LinearBasicDisplay",
          },
        ],
      },

      {
        id: "8TKZI4v2_",
        type: "VariantTrack",
        configuration: "VariantTrack 4",
        displays: [
          {
            id: "bkZVP0qJFL",
            type: "LinearVariantDisplay",
            height: 100,
            configuration: "VariantTrack 4-LinearVariantDisplay",
          },
        ],
      },
    ],
  },
};

export default function Jbrowse() {
  const [viewState, setViewState] = useState<any>();

  useEffect(() => {
    loadPlugins([
      {
        name: "GWAS",
        url: "https://unpkg.com/jbrowse-plugin-gwas/dist/jbrowse-plugin-gwas.umd.production.min.js",
      },
    ]).then((loadedPlugins) => {
      const state = createViewState({
        assembly: assembly,
        tracks: tracks,
        defaultSession: session,
        plugins: loadedPlugins.map((p) => p.plugin),
      });
      setViewState(state);
    });
  }, []);

  if (!viewState) {
    return <div />;
  }
  return <JBrowseLinearGenomeView viewState={viewState} />;
}
